export default __webpack_public_path__ + "static/media/product.cb3e09db.jpg";